import i18next from 'i18next';
/** "Alexander and Ethan", in the kiosk's language */
export const listNames = (names) => new Intl.ListFormat(i18next.language, { style: 'long', type: 'conjunction' }).format(names);
